import React from 'react';
import { Link } from 'gatsby';

// A drop-in replacement for Gatsby's <Link> that is safe against a missing or
// non-string `to`. Prismic link fields that are empty — or that were dropped
// when content was copied to another locale — arrive as objects (e.g.
// { link_type: 'Any' }) or undefined. Passing those straight to Gatsby's <Link>
// throws "path.startsWith is not a function" and fails the static build, so
// here we render the children without a link instead of crashing.
const SafeLink = React.forwardRef(({ to, children, ...props }, ref) => {
  if (typeof to !== 'string' || to === '') {
    return (
      <span ref={ref} {...props}>
        {children}
      </span>
    );
  }

  return (
    <Link ref={ref} to={to} {...props}>
      {children}
    </Link>
  );
});

SafeLink.displayName = 'SafeLink';

export default SafeLink;
